import Toastify from "toastify-js";

class Notification {
  constructor() {
    this.showMessages();
  }

  showMessages() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    // if Successmsg
    const successmsg = urlParams.has("successmsg");
    const successMsg = urlParams.get("successmsg");

    if (successmsg) {
      Toastify({
        text: successMsg,
        gravity: "right",
        position: "center",
        duration: 6000,
        style: {
          color: "#276749",
          background: "#f0fff4",
        },
      }).showToast();
      const clean = new URL(window.location.href);
      clean.searchParams.delete("successmsg");
      const qs = clean.searchParams.toString();
      window.history.replaceState(
        null,
        "",
        clean.pathname + (qs ? "?" + qs : "") + clean.hash
      );
      console.log(`Query string (after):\t ${clean.search}`);
    }

    // if errormsg
    const errormsg = urlParams.has("errormsg");
    const msg = urlParams.get("errormsg");

    if (errormsg) {
      Toastify({
        text: msg,
        gravity: "right",
        position: "center",
        duration: 6000,
        color: "#9b2c2c",
        style: {
          color: "#9b2c2c",
          background: "#fff5f5",
        },
      }).showToast();
      const clean = new URL(window.location.href);
      clean.searchParams.delete("errormsg");
      const qs = clean.searchParams.toString();
      window.history.replaceState(
        null,
        "",
        clean.pathname + (qs ? "?" + qs : "") + clean.hash
      );
      console.log(`Query string (after):\t ${clean.search}`);
    }
  }
}

export default Notification;
